import { queryGiftCardProducts, updateGiftCardProduct } from '@wix/ambassador-gift-cards-v1-gift-card-product/http';
export const updateGiftCardProductAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  if (altTextData.length === 0) {
    return {
      success: true
    };
  }
  // A site has a single GiftCardProduct with one image, so every entry here
  // targets the same product/image. In practice a gift card lives on one page,
  // but we do not rely on that: if the widget appears on multiple pages and the
  // user supplied divergent alt text, only one value could ever be persisted.
  // Rather than silently write the first and report the rest as fixed (data
  // loss + false success), we fail closed and surface the conflict.
  const distinctAlts = new Set(altTextData.map(item => item.alt));
  if (distinctAlts.size > 1) {
    return {
      errorMessage: 'The gift card image is shared across pages; use the same alt text for all of them.',
      failedElements: altTextData,
      success: false
    };
  }
  const altTextItem = altTextData[0];
  try {
    var _queryData$giftCardPr;
    // A site currently has at most one gift card product (backend-enforced; a
    // second create returns GIFT_CARD_PRODUCT_ALREADY_EXISTS), so limit:1 + [0]
    // is safe. Temporary backend limitation: if it is lifted and the widget
    // starts binding a component to a specific product, target that product id
    // here instead of re-querying the first. See design-log 006 (a11y-wizard).
    const {
      data: queryData
    } = await withErrorHandler(async () => httpClient.request(queryGiftCardProducts({
      query: {
        cursorPaging: {
          limit: 1
        }
      }
    })), {
      errorCodesMap: {}
    });
    const product = queryData == null || (_queryData$giftCardPr = queryData.giftCardProducts) == null ? void 0 : _queryData$giftCardPr[0];
    if (!(product != null && product.id) || !product.image) {
      return {
        errorMessage: 'Gift card product not found',
        failedElements: altTextData,
        success: false
      };
    }
    const {
      data: updateData
    } = await withErrorHandler(async () => httpClient.request(updateGiftCardProduct({
      fieldMask: ['image'],
      giftCardProduct: {
        id: product.id,
        image: {
          ...product.image,
          altText: altTextItem.alt
        },
        revision: product.revision
      }
    })), {
      errorCodesMap: {}
    });
    const success = !!(updateData != null && updateData.giftCardProduct);
    return {
      failedElements: success ? [] : altTextData,
      success
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-gift-card-product-alt-text.js.map